import { render, staticRenderFns } from "./BottomDrawerWrapper.vue?vue&type=template&id=197c0c0a&scoped=true&"
import script from "./BottomDrawerWrapper.vue?vue&type=script&lang=js&"
export * from "./BottomDrawerWrapper.vue?vue&type=script&lang=js&"
import style0 from "./BottomDrawerWrapper.vue?vue&type=style&index=0&id=197c0c0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197c0c0a",
  null
  
)

export default component.exports